var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    padding: '100px 0',
    textAlign: 'center'
  })},[_vm._v(" A subscription is necessary to access this feature. ")])}
var staticRenderFns = []

export { render, staticRenderFns }